import React from 'react';
import ReactDOM from 'react-dom';

import Main from './components/Main';

import { addLocaleData } from 'react-intl';

//import { Router, Route, hashHistory } from 'react-router';


import en from 'react-intl/locale-data/en'
import it from 'react-intl/locale-data/it'

addLocaleData([...it, ...en]);

//
// Patch per browser che non gestiscono Api Intl
//--------------------------------------------------

// All modern browsers, expect `Safari`, have implemented
// the `ECMAScript Internationalization API`.
// For that we need to patch in on runtime.
if (!global.Intl)
  require.ensure(['intl'], require => {
    require('intl')
    main()
  }, 'IntlBundle')
else main()

// Funzione che ricava localizzazione direttamente dalle impostazioni del browser
function getLocaleFromBrowser() {
  let browserLanguage;

  if (navigator.language)
  browserLanguage=navigator.language;
  else
  browserLanguage=navigator.browserLanguage;

  let locale = browserLanguage.split('-');
  let res;

  if (locale[1])
	res=locale[0];
  else
	res=navigator.language;

  //console.log("Locale "+ res);

  if (res !== 'it')
    res='en';

  return res;
};


function main() {

    const main    = document.createElement("div");
    document.body.appendChild(main);

    let initialLocale = getLocaleFromBrowser();

    document.title = "Registro.it StatsApp";

    ReactDOM.render(
	     <Main initialLocale={initialLocale}/>, main
    );

}



// WEBPACK FOOTER //
// ./src/index.js